<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>专题查询</span>

        </div>
        <div class="searcharea">
          <label>专题类型:</label>
          <select class="form-control" name="type" v-model="searchParams.type"  style="width: 120px;display: inline-block">
            <option value="">选择专题类型</option>
            <option v-for="(lessonType, key, index) in lesson_type" :value="key">{{lessonType}}</option>
          </select>
          <label>专题名称:</label>
          <input type="text" class="form-control" name="chooseStartDate" style="width: 100px;display: inline-block" v-model="searchParams.name">
          <label>教师姓名:</label>
          <input type="text" class="form-control" name="chooseStartDate" style="width: 100px;display: inline-block" v-model="searchParams.teacherName">
          <label>时间筛选:</label>
          <input type="text" class="form-control" name="chooseStartDate" id="chooseStartDate" style="width: 100px;display: inline-block" v-model="searchParams.startDate" readonly>
          —
          <input type="text" class="form-control" name="chooseEndDate" id="chooseEndDate" style="width: 100px;display: inline-block" v-model="searchParams.endDate" readonly>
          <button type="button" class="btn btn-default btn_option" style="height: 28px;line-height: 15px" @click="initCourseStatisticsListData()">查询</button>
          <button type="button" class="btn btn-default btn_option"
                  style="height: 28px;line-height: 15px"
                  @click="exportClassStatistics()">导出</button>

        </div>
      </div>
      <div class="body_content class_body_content">
        <div class="classStatisticsList_div">
          <table class="table table-striped table-bordered table_classStatistics">
            <thead>
            <tr>
              <th width="5%">序号</th>
              <th width="20%">课程名称</th>
              <th width="20%">班级</th>
              <th width="20%">时间</th>
              <th width="10%">教师</th>
              <th width="10%">上课地点</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(courseStatisticsOne, index) in courseStatisticsList" :key="index">
              <td width="5%">
                {{index + 1}}
              </td>
              <td width="20%">{{courseStatisticsOne.name}}</td>
              <td width="20%">{{courseStatisticsOne.clazzName}}({{courseStatisticsOne.studentNum}}人)</td>
              <td width="20%">{{courseStatisticsOne.startDate}}</td>
              <td width="10%">{{courseStatisticsOne.teacherName}}</td>
              <td width="10%">{{courseStatisticsOne.roomName}}</td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import WorkloadStatistics from '../components/workloadStatistics';
  import pageView from './pageView';
  import dictionaryData from '../json/dictionary';

  export default {
    name: "classStatistics",
    components:{pageView},
    data() {
      return {
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,
        lesson_type: dictionaryData.lesson_type,
        //今日日期
        timeDate: '',

        //课时统计集合
        courseStatisticsList:[],

        //单个教师课时详情集合
        courseDetailsList:[],

        searchParams: {
          name:'',
          teacherName:'',
          startDate:'',
          endDate:'',
          type:'',
          all: 0,
          rows: 10,
          page:1
        },


        checkbox: {
          checkIds: [],
        },

        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },

    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();
        this_.initCourseStatisticsListData();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initCourseStatisticsListData;
        /* window.onbeforeunload = function (e) {
            let storage = window.cookie;
            storage.clear()
          }*/
        //this_.clearCookie();
      });
    },
    methods: {
      /**
       * 课时统计列表
       */
      initCourseStatisticsListData(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
          schoolAxios({
            method: 'get',
            url: 'lesson/findTopic',
            params: _searchParams
          }).then(function (resp) {
            // console.info(resp);
            if (resp.data.success) {
              this_.courseStatisticsList = resp.data.list;
              this_.searchParams.all = resp.data.totalPage;
              this_.searchParams.page = 1;
            }
          });
      },


      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.searchParams.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.searchParams.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },

      /**
       * 导出
       */
      exportClassStatistics(){
        let this_ = this;
        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url:'lesson/exportTopic',
          params: _searchParams
        }).then(function (response) {
          if(response.data.success){
            location.href=this_.hrefExport+response.data.data;
          }else
            (response.data.message||"导出失败").showMessage();
        });
        /* if(teacherIds){
           location.href= this_.hrefExport+'?teacherIds='+this_.checkbox.checkIds.toString()+'&access_token='+this_.token;
         }else {
           "请勾选导出数据".showMessage();
         }*/

      },
      clearCookie() {
        let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        console.info(keys);
        if (keys) {
          for (let i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
            document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
            document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
          }
        }
        console.info(document.cookie);
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/classStatistics.css";
  .table_classStatistics {
    margin: 15px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/workLoad/details_mouseOver.png");
    background-size: 100% 100%;
    margin: 0 0 0 45%;
  }
  .form-group-div {
    margin-top: 10px;
  }
  .form-group label {
    width: 100px;
  }
  .modal-content.modal-work-content {
    width: 900px;
  }
  /*表头固定*/
  .table_details tbody{
    height: 300px;
  }

  .table_classStatistics tbody{
    /*height: 480px;*/
  }

  .searcharea{
    position: absolute;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/topicFind.vue